import React, {CSSProperties} from 'react';
import {Form} from 'react-bootstrap'
import './../switch.scss'
import shortId from 'shortid';

interface ISwitchLayoutProps {
  checked: boolean
  style?: CSSProperties
  className?: string
  disabled?: boolean
  size?: 'small' | 'large'
  label?: string
  onClick: ()=>void
}

const SwitchLayout: React.FC<ISwitchLayoutProps> = (props) => {

  const handleClick = () => {
    if(props.disabled)return
    props.onClick()
  }

    return (
        <div
          className={`switch-component ${props.size ? props.size : ''} ${props.className ? props.className : ''}`}
          style={props.style}
        >
          <Form.Check
            id={shortId.generate()}
            type='switch'
            label={props.label ? props.label : ''}
            checked={props.checked}
            disabled={props.disabled}
            onClick={handleClick}
            onChange={()=>{}}
          />
        </div>
    );
};

export default SwitchLayout;
